// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"dfd09849","79":"dfd09849","391":"30288f52","397":"05eb478d","533":"78fd8ae9"}[chunkId] + ".chunk.css";
};